import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { useGetHeaderHeight } from '@carnica/smart-kit';
import { enhancedConnect } from "../../utils";
import rootStyles from "../../styles/root.pcss";
import styles from "./styles.pcss";
var cn = classNames.bind(_objectSpread(_objectSpread({}, rootStyles), styles));
var _MainBlock = function _MainBlock(_ref) {
  var children = _ref.children,
    backgroundColor = _ref.backgroundColor,
    className = _ref.className;
  var ref = useRef(null);
  var headerHeight = useGetHeaderHeight() || 0;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('main-block', className),
    ref: ref,
    style: {
      backgroundColor: backgroundColor,
      height: "calc(100svh - ".concat(headerHeight, "px)")
    },
    "data-t-id": "components-MainBlock"
  }, children);
};
export var MainBlock = compose(enhancedConnect(), withAutoMetric.Section(function () {
  return {
    name: 'MainBlock'
  };
}))(_MainBlock);